<template>
  <!-- <v-skeleton-loader v-if="loading" type="list-item-avatar-two-line">
  </v-skeleton-loader> -->
  <div>
    <v-menu v-model="menu" bottom>
      <template v-slot:activator="{ on }">
        <v-list-item
          @contextmenu.prevent="openMenu"
          style="cursor: pointer"
          v-on="on"
        >
          <v-list-item-avatar :size="50">
            <v-img :src="img_url">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon>mdi-image-off</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle v-if="serie">
              {{ serie.nome }}
            </v-list-item-subtitle>
            <v-list-item-title>
              {{ colore.nome }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-card>
        <v-list>
          <v-dialog v-model="dialog" width="300">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on">
                <v-list-item-icon
                  ><v-icon color="green">mdi-sprout</v-icon></v-list-item-icon
                >
                <v-list-item-content>
                  <v-list-item-title>Cambia Serie</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-card>
              <v-card-title class="grey--text text-subtitle-1">
                Cambia Serie per
                <span class="blue--text ml-2"> {{ colore.nome }}</span>
              </v-card-title>
              <v-card-text>
                <v-checkbox
                  v-model="nuove_serie"
                  :label="serie.nome"
                  :value="serie.id"
                  v-for="serie in series"
                  :key="serie.id"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text color="grey" @click="dialog = false">chiudi</v-btn>
                <v-btn outlined color="green" @click="cambia_serie()"
                  >Cambia</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogModifica" width="300">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on">
                <v-list-item-icon
                  ><v-icon color="blue">mdi-pencil</v-icon></v-list-item-icon
                >
                <v-list-item-content>
                  <v-list-item-title>Modifica</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-card>
              <v-card-title class="grey--text text-subtitle-1">
                Modifica Colore
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      label="Nome"
                      outlined
                      v-model="colore.nome"
                      prepend-icon="mdi-palette"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="12" class="d-flex justify-center">
                    <v-card
                      class="portrait d-flex justify-center"
                      :img="image_box"
                      height="150"
                      width="150"
                      @click="openFileWindow()"
                    >
                      <v-icon v-if="image_box == ''">mdi-camera</v-icon>
                      <input
                        type="file"
                        style="display: none"
                        @change="onFileChange($event)"
                        ref="input"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  outlined
                  color="green"
                  @click="salva_colore()"
                  :loading="loading"
                  >Salva</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-list-item @click="eliminaColore()">
            <v-list-item-icon
              ><v-icon color="red">mdi-delete</v-icon></v-list-item-icon
            >
            <v-list-item-content>
              <v-list-item-title>Elimina</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-snackbar v-model="snackbarError" color="error" bottom timeout="5000"
      >Impossibile eliminare. Colore collegato a varità</v-snackbar
    >
  </div>
</template>

<script>
export default {
  props: {
    colore: Object,
    id_specie: String,
    series: Array,
  },
  data() {
    return {
      loading: false,
      menu: false,
      dialog: false,
      dialogModifica: false,
      nuove_serie: this.colore.id_series,
      snackbarError: false,
      file: "",
      image_box:
        process.env.VUE_APP_API_ROOT + "/specie/img_colore/" + this.colore.id + "?t=" + this.colore.md5,
    };
  },
  computed: {
    img_url() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie" +
        "/img_colore/" +
        this.colore.id +
        "?t=" +
        this.colore.md5
      );
    },
    serie() {
      return this.$store.getters
        .get_specie_by_id(this.id_specie)
        .series.find((serie) => this.colore.id_series.includes(serie.id));
    },
  },
  methods: {
    eliminaColore() {
      this.$store
        .dispatch("elimina_colore_specie", {
          id_specie: this.id_specie,
          id_colore: this.colore.id,
        })
        .then(() => {})
        .catch((error) => {
          console.error("Errore nell'eliminazione del colore:", error);
          this.snackbarError = true;
        });
    },
    cambia_serie() {
      this.$store
        .dispatch("change_serie_colore_specie", {
          id_specie: this.id_specie,
          id_colore: this.colore.id,
          id_series: this.nuove_serie,
        })
        .then(() => {
          this.dialog = false;
          this.menu = false;
          this.$emit("specie_changed");
        });
    },
    salva_colore() {
      this.loading = true;
      this.$store
        .dispatch("cambia_nome_colore_specie", {
          id_specie: this.id_specie,
          id_colore: this.colore.id,
          nome: this.colore.nome,
        })
        .then(() => {
          this.loading = false;
          this.dialogModifica = false;
        });
      if (this.file) {
        let formData = new FormData();
        formData.append("file", this.file);
        this.$store
          .dispatch("cambia_img_colore_specie", {
            id_specie: this.id_specie,
            id_colore: this.colore.id,
            formData: formData,
          })
          .then(() => {
            this.loading = false;
            this.dialogModifica = false;
            this.$emit("specie_changed");
          });
      }
    },
    openFileWindow() {
      this.$refs.input.click();
    },
    onFileChange(e) {
      this.file = e.target.files[0];
      this.createImage(this.file);
    },
    createImage(file) {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          this.image_box = reader.result;
        },
        false
      );
      reader.readAsDataURL(file);
    },
  },
};
</script>